(ns frontend.ui.component.lp-portal.report.body.real-estate.fund.common.view
  (:require
   [frontend.ui.component.grid.view :as grid]
   [frontend.ui.component.lp-portal.report.esg.key-perf-indicators.view :as esg-kpi]
   [frontend.ui.component.lp-portal.section.view :refer [section]]
   [frontend.ui.component.lp-portal.report.module.chart-card :as chart-card]
   [frontend.ui.component.lp-portal.report.module.free-text-card :as free-text-card]))

(defn esg-section
  [{:keys [esg-targets-and-strategy-text key-performance-indicators renewables scopes gresb
           ungc-esg-incidents-text]
    :as   esg}
   props]
  [section
   "Sustainability"
   (str "esg-"
        (some->> props
                 :report
                 :db/id))
   [:div
    [free-text-card/row-view "Sustainability targets and strategy" esg-targets-and-strategy-text props]
    [esg-kpi/key-perf-indicators-card-re
     key-performance-indicators
     gresb
     props]
    [grid/row {}
     [grid/column {:large 6}
      ;;TODO labels are truncated
      [chart-card/view "Share of fossil-free energy" renewables props]]
     [grid/column {:large 6}
      ;;TODO labels are truncated
      [chart-card/view "Greenhouse gas emissions (tCO2e)" scopes props]]]
    [free-text-card/row-view "UNGC Sustainability incidents" ungc-esg-incidents-text props]]])
